import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Unstable_Grid2'
import Paper from '@mui/material/Paper'
import models from './models/EnvironmentalAndSafetyModels'
import AssessmentCategoryForm from './assessment-components/AssessmentCategoryForm'

const EnvironmentalAndSafetyAssessmentForm = (props = {}) => {
  const [activeCategoriesList, setActiveCategoriesList] = useState()
  const { refreshItemList, subscribeToProgress, defaultAssessmentType } = props

  const getActiveCategories = useCallback(() => {
    if (props.assessment?.filter) {
      const assessmentCategories = JSON.parse(props.assessment.filter)
      return models.filter((m) => {
        return assessmentCategories.includes(m.props.id)
      })
    } else {
      return models
    }
  }, [props.assessment?.filter])

  useEffect(() => {
    setActiveCategoriesList(getActiveCategories())
  }, [getActiveCategories])

  return (
    <Paper sx={{ backgroundColor: 'transparent', border: 'none', boxShadow: 'none', display: 'flex', flexDirection: 'column', flexWrap: 'wrap', width: '98%', margin: '1em auto'}}>    
      <Grid container rowSpacing={2} columnSpacing={{ md: 12 }}>
        <Grid xs={12} md={12}>

        { activeCategoriesList && activeCategoriesList.map(
            (categoryModel, idx) => 
              <AssessmentCategoryForm 
                categoryModel={categoryModel} 
                assessment={props.assessment} 
                key={idx} 
                refreshItemList={refreshItemList}
                progressItemsList={props.progressItemsList}
                subscribeToProgress={subscribeToProgress}
                defaultAssessmentType={defaultAssessmentType} />)}

        </Grid>
      </Grid>
    </Paper>
  )
}

export default EnvironmentalAndSafetyAssessmentForm